import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly activeRequestsSubject = new BehaviorSubject<number>(0);

  readonly isLoading$: Observable<boolean> = this.activeRequestsSubject.pipe(
    map((count) => count > 0),
    distinctUntilChanged(),
  );

  start(): void {
    const current = this.activeRequestsSubject.value;
    this.activeRequestsSubject.next(current + 1);
  }

  stop(): void {
    const current = this.activeRequestsSubject.value;
    this.activeRequestsSubject.next(Math.max(0, current - 1));
  }

  reset(): void {
    this.activeRequestsSubject.next(0);
  }
}
